<template>
  <div class="relative subtitle-holder z-10 mb-4">
    <h2 class="z-10 bg-white inline-block px-4 text-sm mr-4">
      {{ title }}
    </h2>
  </div>
</template>
<script>
export default {
  props: ["title"],
};
</script>
<style lang="scss">
.subtitle-holder {
  h2 {
    color: #040084;
  }
  &::before {
    content: "";
    position: absolute;
    height: 7px;
    width: 100%;
    background: #e4e5e9;
    top: 50%;
    transform: translate(0, -50%);
    z-index: -1;
    border-radius: 100%;
  }
}
</style>
